module.exports = __webpack_public_path__ + "static/media/address.bd828e83.png";